import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import React from 'react'
import useSWR from 'swr'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'

const Index = () => {
  const { data = [], isLoading, isValidating, mutate } = useSWR(['/dlc/drafts'])
  const table = useReactTable({
    data,
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  if (isLoading || isValidating) return <Loader />
  if (!data) return <EmptyDatas />
  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      <div className="flex-shrink-0 mb-2">
        <DataTableToolbar mutate={mutate} />
      </div>
      <div className="flex-1 min-h-0">
        <Card className="h-full flex flex-col">
          <CardContent className="flex-1 overflow-hidden pl-4 pr-0 pb-0">
            <div className="h-full overflow-auto">
              <Table table={table} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default Index
